module.exports = __webpack_public_path__ + "img/app_review_img.09e025a9.png";